import React from 'react';
import { Box, Button, useToast, Tooltip } from '@chakra-ui/react';
import { userHasRequiredPermissions } from 'hooks';
import { FiDownload } from 'react-icons/fi';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { useTranslation } from 'react-i18next';

type DownloadButtonProps = {
  uploadedFile: string;
  fileName: string;
  permissions?: Array<string>;
  title: string;
  description: string;
};

const DownloadButton = ({
  uploadedFile,
  fileName,
  permissions,
  title,
  description,
}: DownloadButtonProps): JSX.Element => {
  const { t } = useTranslation();
  const toast = useToast();
  const hasPermissions = userHasRequiredPermissions(permissions);

  const { mutate, isLoading } = useDownloadFile();

  const handleDownload = () => {
    mutate(
      { url: uploadedFile, fileName },
      {
        onError: (error: any) => {
          toast({
            position: 'bottom',
            isClosable: true,
            title: t('errorOccurred', 'Wystąpił błąd'),
            description:
              error?.message +
              t('operationUnsuccessful', ': Operacja nie powiodła się. '),
            status: 'error',
          });
        },
      },
    );
  };

  return (
    <Tooltip label={description} hasArrow placement='top' openDelay={500}>
      <Box as='span'>
        <Button
          colorScheme='gray'
          onClick={handleDownload}
          ml={3}
          isLoading={isLoading}
          isDisabled={!hasPermissions}
          minWidth='12ch'
          leftIcon={<FiDownload />}
        >
          {title}
        </Button>
      </Box>
    </Tooltip>
  );
};

export default DownloadButton;
